import { useHistory } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import { useContext, useEffect, useState } from 'react';
import DefaultCard from '../../components/default/DefaultCard';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import DefaultModal from '../../components/default/DefaultModal';
import { AppContext } from '../../contexts/AppContext';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import usePurchaseOrderService from '../../app/services/hooks/usePurchaseOrderService';
import { PurchaseorderDataForm, PurchaseOrderFilters } from '../../app/models/PurchaseOrder';
import PurchaseOrderDataTable from './components/tables/PurchaseOrderDataTable';
import PurchaseOrderCreate from './components/PurchaseOrderCreate';
import useNavigationPage from '../../hooks/useNavigationPage';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Ordenes de compra',
        url: '/purchase-orders',
        isActive: true
    }
];

const PurchaseOrders = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingGetPurchaseOrders, getPurchaseOrders, deletePurchaseOrder } = usePurchaseOrderService();
    const history = useHistory();
    const [purchaseOrders, setPurchaseOrders] = useState<PurchaseorderDataForm[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const { navigationPage } = useNavigationPage();

    const [showingCreate, setShowingCreate] = useState(false);

    const [filter, setFilter] = useState<PurchaseOrderFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
    });

    useEffect(() => {
        reloadTable();
    }, [filter]);

    const reloadTable = () => {
        getPurchaseOrders(filter, {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseOrders(response.data.purchase_orders);
                setTotalRows(response.data.total_rows);
                
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (id: number) => {
        navigationPage(`/purchase-orders/${id}/edit`);
       
    };

    const showShow = (id: number) => {
        navigationPage(`/purchase-orders/${id}/show`)
       
    };

   
    const destroy = (purchaseOrderId: number) => {
        const _text = 'Está a punto de eliminar la orden de compra #' + purchaseOrderId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando orden de compra...');
                        deletePurchaseOrder(purchaseOrderId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'La orden de compra no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    return (
        <>
            <Breadcrumbs pageSection="Ordenes de compra" breadcrumbs={breadcrumbs} />
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col">
                                <ButtonCreate
                                    callbackCreate={showCreate}
                                    title="Nueva orden de compra"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <PurchaseOrderDataTable
                            purchaseOrders={purchaseOrders}
                            totalRows={totalRows}
                            loading={fetchingGetPurchaseOrders}
                            destroy={destroy}
                            edit={showEdit}
                            filter={filter}
                            setFilter={setFilter}
                            show={showShow}
                        />
                    </div>
                </div>
            </DefaultCard>
            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear orden de compra"
                    backdrop={true}
                    showFooter={false}
                >
                    <PurchaseOrderCreate
                        onSaved={() => {
                            reloadTable();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default PurchaseOrders;
